import React, { useMemo } from 'react';
import Button from 'atoms/Button/Button';
import { useHeaderCustomization } from 'src/hooks/useHeaderCustomization';

interface HeaderCtaProps {
  callToAction: 'standard' | 'pro';
}

const HeaderCta = ({ callToAction }: HeaderCtaProps): JSX.Element => {
  const { callToAction: customCallToAction } = useHeaderCustomization();

  const callToActionLink = useMemo(() => {
    if (customCallToAction?.link) {
      return customCallToAction.link;
    }

    return callToAction === 'pro' ? '/request-a-call-form' : 'https://cohost.mn.co/?plan=free-trial';
  }, [callToAction, customCallToAction?.link]);

  const callToActionText = useMemo(() => {
    if (customCallToAction?.text) {
      return customCallToAction.text;
    }

    return callToAction === 'pro' ? 'Get a Custom Demo' : 'Start Your Free Trial';
  }, [callToAction, customCallToAction?.text]);

  return (
    <Button
      variant='primary'
      size='lg'
      href={callToActionLink}
    >
      {callToActionText}
    </Button>
  );
};

export default HeaderCta;
